<div class="rich-text-editor-shell">
  <div #toolbarHost class="rich-text-editor-toolbar">
    <span class="ql-formats">
      <select class="ql-header">
        <option value="1"></option>
        <option value="2"></option>
        <option value="3"></option>
        <option value="4"></option>
        <option value="5"></option>
        <option value="6"></option>
        <option selected></option>
      </select>
      <select class="ql-size">
        <option value="small"></option>
        <option selected></option>
        <option value="large"></option>
        <option value="huge"></option>
      </select>
    </span>
    <span class="ql-formats">
      <button type="button" class="ql-bold"></button>
      <button type="button" class="ql-italic"></button>
      <button type="button" class="ql-underline"></button>
      <button type="button" class="ql-strike"></button>
    </span>
    <span class="ql-formats">
      <select class="ql-color"></select>
      <select class="ql-background"></select>
    </span>
    <span class="ql-formats">
      <button type="button" class="ql-script" value="sub"></button>
      <button type="button" class="ql-script" value="super"></button>
    </span>
    <span class="ql-formats">
      <button type="button" class="ql-list" value="ordered"></button>
      <button type="button" class="ql-list" value="bullet"></button>
      <button type="button" class="ql-indent" value="-1"></button>
      <button type="button" class="ql-indent" value="+1"></button>
    </span>
    <span class="ql-formats">
      <select class="ql-align"></select>
      <button type="button" class="ql-direction" value="rtl"></button>
    </span>
    <span class="ql-formats">
      <button type="button" class="ql-blockquote"></button>
      <button type="button" class="ql-code-block"></button>
    </span>
    <span class="ql-formats">
      <button type="button" class="ql-link"></button>
      <button type="button" class="ql-image" title="Image"></button>
      <button type="button" class="ql-video" title="Video"></button>
    </span>
    <span class="ql-formats">
      <button type="button" class="ql-clean"></button>
    </span>
  </div>
  <div class="rich-text-editor-host" #editorHost></div>
</div>
